module.exports = __webpack_public_path__ + "img/table-button.656b217c.svg";